import { useState } from "react";

import { css } from "@emotion/react";

import { sortAndReturnArray } from "shared/functions";
import { COLUMN_RESOURCES, ORDERS } from "shared/types/enums";

import { news } from "../newsData";
import NewsDialog from "../NewsDialog";
import { NewsData } from "../types";
import { useReadNews } from "./hooks";
import NewsItem from "./NewsItem";

const NewsList = () => {
    const { markAsRead, isNewsNew } = useReadNews();
    const [selectedNews, setSelectedNews] = useState<NewsData | null>(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleSelectedNews = (data: NewsData | null) => setSelectedNews(data);

    const handleOpenDialog = (data: NewsData) => {
        setSelectedNews(data);
        setIsDialogOpen(true);
        markAsRead(data.id);
    };

    const handleCloseDialog = () => setIsDialogOpen(false);

    return (
        <div
            css={css({
                display: "flex",
                flexDirection: "column",
                overflowY: "auto",

                "& > button + button": {
                    marginTop: "16px"
                }
            })}
        >
            {sortAndReturnArray(
                news,
                COLUMN_RESOURCES.Id,
                ORDERS.Descending
            ).map(newsItem => {
                const { id, createdAt } = newsItem;

                return (
                    <NewsItem
                        key={id}
                        data={newsItem}
                        isNew={isNewsNew(id, createdAt)}
                        onClick={handleOpenDialog}
                    />
                );
            })}

            {isDialogOpen && selectedNews && (
                <NewsDialog
                    isOpen
                    data={selectedNews}
                    onClose={handleCloseDialog}
                    handleSelectedNews={handleSelectedNews}
                />
            )}
        </div>
    );
};

export default NewsList;
